import mapSearchAndReplace from "./mapSearchAndReplace"

/**
 *
 * @param {string} messageValue
 */
const replaceHTMLTag = (messageValue = '') =>{

    var htmlReplace = messageValue;
    for (let x = 0; x < mapSearchAndReplace().length; x++) {
        htmlReplace = htmlReplace.replaceAll(mapSearchAndReplace()[x].search, mapSearchAndReplace()[x].replace);
    }

    return htmlReplace.replaceAll(/&lt;/g, '<').replaceAll(/&gt;/g, '>').replaceAll(/&amp;/g, '&');

}

export default replaceHTMLTag;
